import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import background from "../image/back.png";
import logo from "../image/USA_transparent (2).png";
import contactImage from "../image/ph8.jpg";
import { Facebook } from "lucide-react";
import { ToastContainer, toast } from "react-toastify"; // ✅ Import Toastify
import "react-toastify/dist/ReactToastify.css"; // ✅ Import Toastify CSS

const ContactPage = () => {
    useEffect(() => {
      const NUM_BALLS = 18;
      const balls = [];
      const colors = [
        "#f1f5ff", // very light blue
        "#a5b4fc", // soft indigo
        "#fcd34d", // soft yellow
        "#fca5a5", // soft red
        "#6ee7b7", // soft green
        "#f9a8d4", // soft pink
        "#c7d2fe", // blue-gray
        "#fff"
      ];
      const container = document.getElementById("randomBallsBg");
      if (!container) return;
      container.innerHTML = "";
      const footer = document.querySelector("footer");
      let footerHeight = 0;
      if (footer) {
        footerHeight = footer.offsetHeight;
      }
      const W = window.innerWidth;
      const H = window.innerHeight - footerHeight;
      for (let i = 0; i < NUM_BALLS; i++) {
        const ball = document.createElement("div");
        const size = Math.random() * 18 + 12;
        ball.className = "random-ball";
        ball.style.width = `${size}px`;
        ball.style.height = `${size}px`;
        ball.style.background = colors[Math.floor(Math.random() * colors.length)];
        ball.style.left = `${Math.random() * (W - size)}px`;
        ball.style.top = `${Math.random() * (H - size)}px`;
        container.appendChild(ball);
        balls.push({
          el: ball,
          x: parseFloat(ball.style.left),
          y: parseFloat(ball.style.top),
          dx: (Math.random() - 0.5) * 1.5,
          dy: (Math.random() - 0.5) * 1.5,
          size,
        });
      }
      let running = true;
      function animate() {
        if (!running) return;
        for (const b of balls) {
          b.x += b.dx;
          b.y += b.dy;
          if (b.x < 0 || b.x > W - b.size) b.dx *= -1;
          if (b.y < 0 || b.y > H - b.size) b.dy *= -1;
          b.x = Math.max(0, Math.min(W - b.size, b.x));
          b.y = Math.max(0, Math.min(H - b.size, b.y));
          b.el.style.transform = `translate(${b.x}px, ${b.y}px)`;
        }
        requestAnimationFrame(animate);
      }
      animate();
      return () => {
        running = false;
        if (container) container.innerHTML = "";
      };
    }, []);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .send(
        "service_rc6rard", // ✅ Updated EmailJS Service ID
        "template_fc9smm1", // ✅ Your EmailJS Template ID
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
        },
        "YB_0Cnu18PoH_121o" // ✅ Updated EmailJS Public Key
      )
      .then(() => {
        toast.success("Message sent successfully!"); // ✅ Success Toast
        setFormData({ name: "", email: "", message: "" });
        setLoading(false);
      })
      .catch((error) => {
        console.error("Failed to send message:", error);
        toast.error("Failed to send message. Please try again."); // ✅ Error Toast
        setLoading(false);
      });
  };

  return (
    <div className="relative flex items-center justify-center bg-lightblue min-h-screen overflow-hidden">
      {/* Animated Random Balls Background */}
      <div className="random-balls-bg" id="randomBallsBg"></div>
      {/* Toast Container */}
      <ToastContainer position="top-center" autoClose={3000} />


      {/* Content Section */}
      <div className="relative items-center justify-center min-h-screen p-6 w-full max-w-4xl">
        <div className="bg-white rounded-lg shadow-lg flex flex-col md:flex-row w-full overflow-hidden">
          {/* Left Side */}
          <div className="bg-[#002E63] text-white p-8 flex-1 flex flex-col justify-between">
            <div className="flex items-center space-x-4 mb-6">
              <img src={logo} alt="Universal Science Academy Logo" className="w-16 h-16" />
              <h1 className="text-2xl font-bold">Universal Science Academy</h1>
            </div>

            <div className="flex justify-center mb-6">
              <img src={contactImage} alt="Contact" className="w-full h-48 object-cover rounded-lg" />
            </div>

            <div>
              <h2 className="text-xl font-bold">
                Let's discuss something <span className="text-pink-400">exciting</span> together!
              </h2>
              <div className="mt-4 space-y-2">
                <p className="flex items-center space-x-2">
                  <Facebook className="w-5 h-5 text-blue-600" />
                  <a
                    href="https://www.facebook.com/share/18szF5de1G/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline hover:text-pink-400"
                  >
                    Universal Science Academy
                  </a>
                </p>
                <p className="flex items-center space-x-2">
                  <span>📧</span>
                  <a
                    href="mailto:universalscienceacademyjaffna@gmail.com"
                    className="underline hover:text-pink-400"
                  >
                    universalscienceacademyjaffna@gmail.com
                  </a>
                </p>
                <p className="flex items-center space-x-2">
                  <span>📞</span>
                  <a href="tel:+94779966888" className="underline hover:text-pink-400">
                    +94779966888
                  </a>
                </p>
                <p className="flex items-center space-x-2">
                  <span>📍</span>
                  <a
                    href="https://www.google.com/maps/search/?api=1&query=Chunnagam+Jaffna"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="underline hover:text-pink-400"
                  >
                    K.K.S Road, Chunnakam, Jaffna
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="p-8 flex-1">
            <h2 className="text-lg font-bold mb-6 text-gray-700">Contact Us</h2>
            <form onSubmit={handleSubmit} className="space-y-5" autoComplete="off">
              <div>
                <label htmlFor="name" className="block font-medium text-gray-700">
                  Your Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Enter your name"
                  className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#002E63]"
                  required
                />
              </div>
              <div>
                <label htmlFor="email" className="block font-medium text-gray-700">
                  Your Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#002E63]"
                  required
                />
              </div>
              <div>
                <label htmlFor="message" className="block font-medium text-gray-700">
                  Your Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="4"
                  placeholder="Type your message..."
                  className="w-full p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-[#002E63]"
                  required
                ></textarea>
              </div>
              <button
                type="submit"
                className="w-full bg-[#002E63] text-white py-3 rounded-lg font-semibold hover:bg-[#004ba8] transition duration-200 shadow-lg"
                disabled={loading}
              >
                {loading ? "Sending..." : "Send Message"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
